// Where to go after signing in: members whose profile isn't complete yet
// (new Google accounts) first finish it; otherwise ?next= (same-site paths
// only, so a crafted link can't bounce anyone elsewhere) or the default.
export function safeNext(next) {
  return next && next.startsWith('/') && !next.startsWith('//') ? next : null;
}

export function afterSignIn(user, next) {
  if (user.role !== 'admin' && !user.profileComplete) {
    return `/account/complete-profile${next ? `?next=${encodeURIComponent(next)}` : ''}`;
  }
  return safeNext(next) || (user.role === 'admin' ? '/admin' : '/account');
}
